import { useQuery } from '@tanstack/react-query';

import { Space } from 'src/features/spaces/utils/types';
import axios from 'src/lib/axios';
import { QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

const RESOURCE = `sp-core/:parkingId/sites/space/:spaceId/`;

type QueryFnType = typeof queryFn;

interface DTO {
    spaceId: string;
    parkingId: string;
}
const queryFn = ({ spaceId, parkingId }: DTO): Promise<Space> => {
    return axios.get(formatResourcePath(RESOURCE, { spaceId, parkingId }));
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetSpace };
